import React, { memo } from 'react';
import { FlexView } from '@cuemath/comps';
import { Separator, Text } from '@cuemath/web-comps';
import { CopyButton } from 'comps';
import COLORS from 'constants/colors';
import { REVIEW_STATUS_CONFIG } from 'constants/av-review';
import {
  HeaderContainer,
  Divider,
  StatusBadge,
  ProgressWrapper,
  ProgressBar,
  ProgressFill,
} from './header-bar-styled';

const HeaderBar = ({ review, reviewProgress }) => {
  const { teacher_classroom, status } = review || {};
  const { teacher_id, class_type, session_date } = teacher_classroom || {};
  const statusConfig = REVIEW_STATUS_CONFIG[status] || {};
  const { reviewed = 0, total = 0 } = reviewProgress || {};
  const percent = total > 0 ? Math.round((reviewed / total) * 100) : 0;

  return (
    <HeaderContainer flexDirection="row" alignItems="flex-start" gutter={16}>
      <FlexView gap={16}>
        <Text variant="eyebrow2" color={COLORS.COLA_LIGHT}>Classroom ID</Text>
        <CopyButton copyMessage="Copy Classroom ID" text={review?.teacher_classroom_id || '-'} customTextStyle />
      </FlexView>
      <Divider />
      <FlexView gap={16}>
        <Text variant="eyebrow2" color={COLORS.COLA_LIGHT}>Teacher ID</Text>
        <CopyButton copyMessage="Copy Teacher ID" text={teacher_id} customTextStyle />
      </FlexView>
      <Divider />
      <FlexView gap={16}>
        <Text variant="eyebrow2" color={COLORS.COLA_LIGHT}>Type</Text>
        <Separator height={12} />
        <Text variant="cta2" color={COLORS.COLA}>{class_type || '-'}</Text>
      </FlexView>
      <Divider />
      <FlexView gap={16}>
        <Text variant="eyebrow2" color={COLORS.COLA_LIGHT}>Class date</Text>
        <Separator height={12} />
        <Text variant="cta2" color={COLORS.COLA}>{session_date || '-'}</Text>
      </FlexView>
      <Divider />
      <FlexView gap={16}>
        <Text variant="eyebrow2" color={COLORS.COLA_LIGHT}>Status</Text>
        <Separator height={12} />
        {status && (
          <StatusBadge color={statusConfig.color} bgColor={statusConfig.bgColor}>
            <Text variant="body2" color={statusConfig.color}>{statusConfig.label || status}</Text>
          </StatusBadge>
        )}
      </FlexView>
      <Divider />
      <FlexView gap={16}>
        <Text variant="eyebrow2" color={COLORS.COLA_LIGHT}>Progress</Text>
        <Separator height={12} />
        <ProgressWrapper flexDirection="row" alignItems="center" gap={8}>
          <ProgressBar>
            <ProgressFill percent={percent} />
          </ProgressBar>
          <FlexView flexDirection="row" alignItems="center">  
            <Text variant="cta2" color={COLORS.BLACK_T_60}>{reviewed}/{total}&nbsp;</Text>
            <Text variant="body3" color={COLORS.BLACK_T_60}>
              reviewed
            </Text>
          </FlexView>
        </ProgressWrapper>
      </FlexView>
    </HeaderContainer>
  );
};

export default memo(HeaderBar);
